var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronup = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M21.207 16.707a1 1 0 0 1-1.414 0L12 8.914l-7.793 7.793a1 1 0 0 1-1.414-1.414l8.5-8.5a1 1 0 0 1 1.414 0l8.5 8.5a1 1 0 0 1 0 1.414",
  clipRule: "evenodd"
})));
export default SvgChevronup;